import { render, staticRenderFns } from "./AboutPage.vue?vue&type=template&id=34f114cc&"
var script = {}
import style0 from "./AboutPage.vue?vue&type=style&index=0&id=34f114cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports